<template src="./DashboardMain.html" lang="html"></template>

<script>
import mixins from "../../../../Mixins.js";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
export default {
  mixins: [mixins],
    components: {
    ECharts
  },
  data() {
    return {
      confirmed: 0,
      concluded: 0,
      patients :0,
      waitingMatch: 0,
      medicalRecordWaiting : 0,
      netBalance: 0,
       pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "Solicitação de consultas",
            "Consultas agendadas",
            "Prontuários finalizados",
            "Prontuários pendentes",
            "Pacientes atendidos"
          ]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            color: ["#FF0000", "#508cc8", "#3c6997", "#78c8be", "#fd7e14"],
            data: [
              { value: 0, name: "Solicitação de consultas" },
              { value: 0, name: "Consultas agendadas" },
              { value: 0, name: "Prontuários finalizados" },
              { value: 0, name: "Prontuários pendentes" },
              { value: 0, name: "Pacientes atendidos" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      }
    }
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getDashBoardDate();
    },
    getDashBoardDate() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/dashboard",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.waitingMatch = response.data.scheduleWait;
            vm.confirmed = response.data.appointmentsSchedule;
            vm.concluded = response.data.medicalRecordsFinished;
            vm.medicalRecordWaiting = response.data.medicalRecordsPendent;
            vm.patients = response.data.patientsSeen;
            vm.updateChart();
          }
        });
    },
    updateChart() {
      const vm = this;
      vm.pie.series[0].data = [
        { value: vm.waitingMatch, name: "Solicitação de consultas" },
        { value: vm.confirmed, name: "Consultas agendadas" },
        { value: vm.concluded, name: "Prontuários finalizados" },
        { value: vm.medicalRecordWaiting, name: "Prontuários pendentes" },
        { value: vm.patients, name: "Pacientes atendidos" }
      ];
    }
  }
};
</script>

<style src="./DashboardMain.scss" lang="scss">
</style>
